// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tgES","name":"styles_name__3JYG6","phone":"styles_phone__2LkPm"};